module.exports = "/images/f6ad9b66899c214f6dd822b383151238.png";